import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Event,
  RouterStateSnapshot,
  UrlTree,
} from "@angular/router";
import { Observable } from "rxjs";
import { AuthService } from "../pages/services/auth-services.service";
import { Router, ActivatedRoute, NavigationEnd } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class Auth2Guard implements CanActivate {
  public menuItems: any;
  public canActivateUrl: any;

  constructor(
    private auth: AuthService,
    public activeRoute: ActivatedRoute,
    public router: Router
  ) {}

  get currentUser() {
    const user = JSON.parse(localStorage.getItem("userInfo"));
    return user && user.data && user.data.principal
      ? user.data.principal
      : null;
  }

  getActivationStatus(status) {
    console.log("can activate", status);
    this.canActivateUrl = status;
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    this.menuItems =
      this.currentUser && this.currentUser.roles
        ? this.currentUser.roles
            .flatMap((menu) => menu.menuList)

            .filter(
              (menu, index, menuItems) =>
                menuItems.findIndex((item) => item.id === menu.id) === index // <=== removes duplicates menus for user with multiple roles
            )
            .sort((a, b) => {
              return a.sorting > b.sorting ? 1 : -1;
            })
        : [];

    let canActivate =
      this.menuItems.filter((item) => item.routerLink === state.url).length > 0
        ? true
        : false;

    if (this.auth.hasSession && canActivate) {
      /** checks if router url exists on user menus before allowing to next */

      return true;
    } else {
      this.router.navigate(["/not-found"]);
    }

    // else {
    //   if (this.auth.hasSession) {
    //     this.router.navigate(["/main"]);
    //   } else {
    //   }
    // }
  }
}
